import { QueryType } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';

const NON_FILTER_PARAMS = new Set(['search', 'sort', 'page', 'queryType']);

export function formatFiltersFromParams(params: {
  getAll: () => Record<string, string[]>;
}): string[] {
  const allParams = params.getAll();
  const filters: string[] = [];

  for (const [field, values] of Object.entries(allParams)) {
    if (NON_FILTER_PARAMS.has(field)) continue;
    for (const value of values) {
      filters.push(`${field}__${value}`);
    }
  }

  return filters;
}

// AI-powered search types
export const AI_QUERY_TYPES = ['LLM', 'VAAS'] as const;
export type AiQueryType = (typeof AI_QUERY_TYPES)[number];

// Type guard to identify AI-powered searches
export const isAiQueryType = (
  type: QueryType | string | undefined
): type is AiQueryType => AI_QUERY_TYPES.includes(type as AiQueryType);

// Sort field for maintaining AI result order
export const ORDERED_LISTING_ID = 'ORDERED_LISTING_ID' as const;
export const ASC = 'ASC' as const;
